<template>
    <div>
        <h2>Profil Bilgileri</h2>
        <p v-if="user">Hoş geldin, {{ user.username }}!</p>
        <button @click="logout">Çıkış Yap</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: null
        }
    },
    async created() {
        try {
            const response = await this.$axios.get('user/')
            this.user = response.data
        } catch (error) {
            console.error('Kullanıcı bilgisi alınamadı:', error)
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('access')
            localStorage.removeItem('refresh')
            this.$router.push('/login')
        }
    }
}
</script>